
import _ from 'lodash'

export default {
    props: {
        value: {
            type: [String, Number, Object],
            default: null,
        },
        minQuery: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Select Optional Group',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        internalSearch: {
            type: Boolean,
            default: false,
        },
        showNoOptions: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        allowOther: {
            type: Boolean,
            default: false,
        },
        helpText: {
            type: String,
            default: null,
        },
        levels: {
            type: Array,
            default: () => [], // e.g. ['paying', 'financial_advisor', 'dpc']
        },
    },
    data () {
        return {
            selectableOptions: [],
            groupValue: null,
        }
    },
    async fetch () {
        const query = this.query || ''
        if (this.minQuery && query.length < this.minQuery) {
            this.selectableOptions = []
            return
        }
        const levels = this.levels || []
        const params = {}
        for (const level of levels) {
            params[level] = true
        }
        const { items } = await this.$api.getGroups({ query, ...params })
        if (this.allowOther && (!items.length || items[0].id)) {
            items.unshift({ id: null, name: 'Other' })
        }
        this.selectableOptions = items || []
    },
    computed: {
        computedPlaceholder () {
            return this.minQuery ? 'Search Employer Groups' : this.placeholder || 'Select Employer Group'
        },
    },
    watch: {
        value () {
            if (!_.isEqual(parseInt(this.value), this.groupValue?.id)) {
                this.updateValue()
            }
        },
        groupValue () {
            this.emitInput()
        },
    },
    mounted () {
        this.updateValue()
    },
    methods: {
        async updateValue () {
            if (this.value) {
                const group = await this.$api.getGroup(this.value)
                this.groupValue = group
            } else {
                this.groupValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.groupValue?.id || null)
            this.$emit('input-raw', this.groupValue || null)
        },
        search (query) {
            this.query = query
            return this.$fetch()
        },
    },
}
